<div class="flex justify-between items-center mb-4">
  <ng-content select="[slot=header]"></ng-content>
  <ng-content select="[slot=actions-top]"></ng-content>
</div>

<mat-table [dataSource]="timesheets()" class="w-full" [class.min-w-340]="showKekaMetadata()">
  <!-- Source Column -->
  <ng-container matColumnDef="source">
    <mat-header-cell *matHeaderCellDef class="font-semibold">Source</mat-header-cell>
    <mat-cell *matCellDef="let timesheet">
      <span class="font-medium">{{ timesheet.source.name | titlecase }}</span>
    </mat-cell>
  </ng-container>

  <!-- Day Columns -->
  @for (day of weekDays(); track day.date) {
    <ng-container [matColumnDef]="day.date">
      <mat-header-cell *matHeaderCellDef class="text-center">
        <div class="flex flex-col">
          <span class="text-xs text-gray-500">{{ day.day | titlecase }}</span>
          <span class="font-semibold">{{ day.label }}</span>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let timesheet" class="text-center">
        <app-timesheet-row-cell
          [weekDays]="weekDays()"
          [entry]="getEntry(timesheet, day.date)"
          [showAttendanceSource]="showKekaMetadata() && timesheet.source.is_trusted"
          [isEditing]="isEditing(timesheet)"
          [hasError]="hasError(timesheet, day.date)"
          [isWithinTrusted]="isWithinTrusted(timesheet, day.date)"
          (hoursChanged)="onHoursChanged(timesheet.id || timesheet.source_id, day.date, $event)"
        />
      </mat-cell>
    </ng-container>
  }

  <!-- Total Column -->
  <ng-container matColumnDef="total">
    <mat-header-cell *matHeaderCellDef class="font-semibold text-center">Total</mat-header-cell>
    <mat-cell *matCellDef="let timesheet" class="text-center font-medium">
      {{ getTotal(timesheet) }}
    </mat-cell>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef class="w-24"></mat-header-cell>
    <mat-cell *matCellDef="let timesheet" class="w-24">
      @if (!timesheet.source.is_trusted) {
        @if (isEditing(timesheet)) {
          <div class="flex gap-1">
            <button mat-icon-button (click)="onSaveClick(timesheet)" matTooltip="Save">
              <mat-icon class="text-green-600">check</mat-icon>
            </button>
            <button mat-icon-button (click)="onCancelClick(timesheet)" matTooltip="Cancel">
              <mat-icon class="text-red-600">close</mat-icon>
            </button>
          </div>
        } @else {
          <button mat-icon-button (click)="onEditClick(timesheet)" matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
        }
      }
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
</mat-table>

<ng-content select="[slot=actions-bottom]"></ng-content>
